import { TranslationContext } from 'contexts/translation-context';
import styled from 'styled-components';
import { useEffect, useState, useContext } from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { FormikProps } from 'formik';
import { JoinFormType } from 'types/join';

const TitleText = styled.div`
  font-family: ${props => props.theme.fonts.montserratSemiBold};
  font-size: 11px;
  color: #9b9b9b;
  margin-right: 4px;
`;

const Text = styled.div`
  font-family: ${props => props.theme.fonts.montserratMedium};
  font-size: 11px;
  color: #9b9b9b;
`;

const Subscribe = styled.div`
  font-family: ${props => props.theme.fonts.montserratMedium};
  font-size: 13px;
  color: #434343;
  margin-left: 9px;
`;

const CheckboxContainer = styled.div`
  margin-left: 12px;
`;

const StyledCheckbox = styled(Checkbox)`
  padding: 2px;
  && {
    & .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    }
    & .MuiFormControlLabel-label {
      font-family: 'Montserrat-Medium', sans-serif;
      font-size: 11px;
      display: flex;
      align-items: center;
    }
  }
`;

const StyleToggle = styled.div`
  color: ${props => props.theme.colors.siteBlue};
  text-decoration: underline;
  margin-top: 2px;
  cursor: pointer;
  font-size: 13px;
  font-family: 'Montserrat-Medium', sans-serif;
`;

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const NewsLettersMoreDetailsContent = ({
  form,
  disabled = false
}: {
  form: FormikProps<JoinFormType>;
  disabled: boolean;
}) => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const [someSelected, setSomeSelected] = useState([false, false, false, false]);
  const [selectAll, setSelectAll] = useState(false);

  const toggleMoreDetails = () => {
    setShowMoreDetails(!showMoreDetails);
  };

  const toggleSelectAll = (val: boolean) => {
    form.setFieldValue('newsBriefNewsletter', !val);
    form.setFieldValue('tradeWireNewsletter', !val);
    form.setFieldValue('weeklyJewelryNewsletter', !val);
    form.setFieldValue('biMonthlyMagazineOnline', !val);
  };

  useEffect(() => {
    if (form.values) {
      const {
        newsBriefNewsletter,
        tradeWireNewsletter,
        weeklyJewelryNewsletter,
        biMonthlyMagazineOnline
      } = form.values;
      setSomeSelected([
        newsBriefNewsletter,
        tradeWireNewsletter,
        weeklyJewelryNewsletter,
        biMonthlyMagazineOnline
      ]);
      setSelectAll(
        newsBriefNewsletter &&
          tradeWireNewsletter &&
          weeklyJewelryNewsletter &&
          biMonthlyMagazineOnline
      );
    }
  }, [form.values]);

  return (
    <CheckboxContainer>
      <div style={{ display: 'flex' }}>
        <FormControlLabel
          label={<Subscribe>{TRANSLATION_TEXT.subscribe_to_rapaport_newsletters}</Subscribe>}
          control={
            <StyledCheckbox
              disabled={disabled}
              checked={selectAll && someSelected.every(Boolean)}
              indeterminate={!selectAll && someSelected.some(Boolean)}
              onChange={() => toggleSelectAll(selectAll)}
              color="primary"
            />
          }
        />

        {/* {anyAdditionalChecked && !subscribeToNewsletters && <span>-</span>} */}
        <StyleToggle onClick={toggleMoreDetails}>
          {showMoreDetails ? 'Less Details' : 'More Details'}
        </StyleToggle>
      </div>
      {showMoreDetails && (
        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3, color: '#9B9B9B' }}>
          <FormControlLabel
            control={
              <StyledCheckbox
                disabled={disabled}
                name="newsBriefNewsletter"
                checked={form.values.newsBriefNewsletter}
                onChange={form.handleChange}
              />
            }
            label={
              <FlexWrapper>
                <TitleText>{TRANSLATION_TEXT.daily_news_brief}</TitleText>
                <Text>{TRANSLATION_TEXT.a_daily_news_digest_delivered}`</Text>
              </FlexWrapper>
            }
          />

          <FormControlLabel
            control={
              <StyledCheckbox
                disabled={disabled}
                name="tradeWireNewsletter"
                checked={form.values.tradeWireNewsletter}
                onChange={form.handleChange}
              />
            }
            label={
              <FlexWrapper>
                <TitleText>{TRANSLATION_TEXT.weekly_trade_wire}</TitleText>
                <Text>{TRANSLATION_TEXT.a_weekly_newsletter_sent}</Text>
              </FlexWrapper>
            }
          />

          <FormControlLabel
            control={
              <StyledCheckbox
                disabled={disabled}
                name="weeklyJewelryNewsletter"
                checked={form.values.weeklyJewelryNewsletter}
                onChange={form.handleChange}
              />
            }
            label={
              <FlexWrapper>
                <TitleText>{TRANSLATION_TEXT.weekly_jewelry}</TitleText>
                <Text>{TRANSLATION_TEXT.your_source_for_essential}</Text>
              </FlexWrapper>
            }
          />

          <FormControlLabel
            control={
              <StyledCheckbox
                disabled={disabled}
                name="biMonthlyMagazineOnline"
                checked={form.values.biMonthlyMagazineOnline}
                onChange={form.handleChange}
              />
            }
            label={
              <FlexWrapper>
                <TitleText>{TRANSLATION_TEXT.bi_monthly}</TitleText>
              </FlexWrapper>
            }
          />
        </Box>
      )}
    </CheckboxContainer>
  );
};

export default NewsLettersMoreDetailsContent;
